import styled from "styled-components";
import { BtnLinked } from "components/styles/smallComponents";
import { carritoController } from "utils/carritoControllers";
import { FRONTEND_ENDPOINTS } from "Theconstants";
import { HASH_LINKS } from "Theconstants";
import React from "react";
import { RootState } from "context/store";

export const Container = styled.div``;
export const TotalProd = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: bold;
  font-size: var(--fontBig);
  padding: 10px;
`;

const LinkMe = styled(BtnLinked)`
  font-size: calc(var(--fontBig) - 0.2rem);
`;
export const Total: React.FC<{ carrito: RootState["user"]["carrito"] }> = ({
  carrito,
}) => {
  return (
    <Container>
      <TotalProd>
        <span>Total</span>
        <span>${carritoController.getTotal(carrito)}</span>
      </TotalProd>

      <LinkMe
        to={`${FRONTEND_ENDPOINTS.CHECKOUT}#${HASH_LINKS.TOP}`}
        bc={"var(--mainGreen)"}
        border={"var(--mainGreenHover)"}
      >
        Ir a pagar
      </LinkMe>
    </Container>
  );
};
